import PropTypes from 'prop-types';
import React from 'react';

import StyledDidYouKnowDivider from './didYouKnowDivider.style';
import Container from '../../layout/container/container';
import Headline from '../../atoms/headline/headline';
import MixedCopy from '../mixed-copy/mixedCopy';
import DidYouKowIconDesktop from '../../icons/didYouKnowDesktop.svg';
import DidYouKnowIconMobile from '../../icons/didYouKnowMobile.svg';

const DidYouKnowDivider = ({ headline, copy, hint, color = 'blue', alignment = 'right' }) => (
  <StyledDidYouKnowDivider color={color} alignment={alignment}>
    <div className="didYouKnowDivider__wrapper">
      <Container>
        <div className="didYouKnowDivider__content">
          <DidYouKowIconDesktop className="didYouKnowDivider__icon didYouKnowDivider__icon--desktop" />
          <DidYouKnowIconMobile className="didYouKnowDivider__icon didYouKnowDivider__icon--mobile" />
          <div className="didYouKnowDivider__text">
            <Headline secondary>{headline}</Headline>
            <MixedCopy className="didYouKnowDivider__copy" html={copy} />
            {hint && <MixedCopy className="didYouKnowDivider__hint" html={hint} />}
          </div>
        </div>
      </Container>
    </div>
    <div className="didYouKnowDivider__dots" />
  </StyledDidYouKnowDivider>
);

DidYouKnowDivider.propTypes = {
  headline: PropTypes.string.isRequired,
  copy: PropTypes.string.isRequired,
  color: PropTypes.string,
  alignment: PropTypes.oneOf(['left', 'right']),
  hint: PropTypes.string
};

export default DidYouKnowDivider;
